import { Row, Col, Form, Button } from "react-bootstrap"
import { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { getThreeRiversItems, resetItems } from "../../../../../../redux/actions/account";
import { IAppState } from "../../../../../../redux/storeTypes";
import { clearItemSearch, setItemSearch } from "../../../../../../redux/actions/orderManagement";

interface IThreeRiversSearch {
    billNumberLabel: string,
    billNumberPlaceholder: string,
    searchHelpText: string,
    searchLabel: string,
    resetLabel: string,
    margin: string,
    padding: string,
    resetButtonBackgroundColor: string,
    resetButtonFontColor: string,
    resetButtonFontSize: string,
    resetButtonFontStyle: string,
    resetButtonFontWeight: string,
    resetButtonBorderColor: string,
    submitButtonBackgroundColor: string,
    submitButtonFontColor: string,
    submitButtonFontSize: string,
    submitButtonFontStyle: string,
    submitButtonFontWeight: string,
    billNumberWildcard?: boolean,
    isFetching?: boolean,
}

export const BILL_NUMBER_METADATA_KEY = 'AccountNumber';

export const BILL_NUMBER_LABEL = 'Bill Number';
export const BILL_NUMBER_PLACEHOLDER = 'Enter bill number';
export const SEARCH_HELP_TEXT = '';
export const SEARCH_LABEL = 'Search';
export const RESET_LABEL = 'Reset';
export const MARGIN = '0px';
export const PADDING = '0px';
export const RESET_BUTTON_FONT_COLOR = '#414141';
export const RESET_BUTTON_FONT_SIZE = '.875rem';
export const RESET_BUTTON_FONT_STYLE = 'normal';
export const RESET_BUTTON_FONT_WEIGHT = 'normal';
export const RESET_BUTTON_BORDER_COLOR = '#D9D9D9';
export const RESET_BUTTON_BACKGROUND_COLOR = '#FFFFFF';
export const SUBMIT_BUTTON_FONT_COLOR = '#FFFFFF';
export const SUBMIT_BUTTON_FONT_SIZE = '.875rem';
export const SUBMIT_BUTTON_FONT_STYLE = 'normal';
export const SUBMIT_BUTTON_FONT_WEIGHT = 'normal';
export const SUBMIT_BUTTON_BACKGROUND_COLOR = '#0057b6';
export const BILL_NUMBER_WILDCARD = false;

const checkStyleForDefault = (style: string, defaultStyle: string) => {
    return style && style !== '' ? style : defaultStyle;
}

const checkStyleForDefault3 = (defaultStyle: string) => {
    return defaultStyle as any;
}

const ThreeRiversSearch = ({ billNumberLabel, billNumberPlaceholder, searchHelpText, searchLabel, resetLabel,
    margin, padding, resetButtonBackgroundColor, resetButtonFontColor, resetButtonFontSize, resetButtonFontStyle, resetButtonFontWeight, resetButtonBorderColor,
    submitButtonBackgroundColor, submitButtonFontColor, submitButtonFontSize, submitButtonFontStyle, submitButtonFontWeight, billNumberWildcard, isFetching }: IThreeRiversSearch) => {

    if (!billNumberLabel) { billNumberLabel = BILL_NUMBER_LABEL }
    if (!billNumberPlaceholder) { billNumberPlaceholder = BILL_NUMBER_PLACEHOLDER }
    if (!searchHelpText) { searchHelpText = SEARCH_HELP_TEXT }
    if (!searchLabel) { searchLabel = SEARCH_LABEL }
    if (!resetLabel) { resetLabel = RESET_LABEL }
    if (!margin) { margin = MARGIN }
    if (!padding) { padding = PADDING }
    if (!resetButtonBackgroundColor) { resetButtonBackgroundColor = RESET_BUTTON_BACKGROUND_COLOR }
    if (!resetButtonFontColor) { resetButtonFontColor = RESET_BUTTON_FONT_COLOR }
    if (!resetButtonFontSize) { resetButtonFontSize = RESET_BUTTON_FONT_SIZE }
    if (!resetButtonFontStyle) { resetButtonFontStyle = RESET_BUTTON_FONT_STYLE }
    if (!resetButtonFontWeight) { resetButtonFontWeight = RESET_BUTTON_FONT_WEIGHT }
    if (!resetButtonBorderColor) { resetButtonBorderColor = RESET_BUTTON_BORDER_COLOR }
    if (!submitButtonBackgroundColor) { submitButtonBackgroundColor = SUBMIT_BUTTON_BACKGROUND_COLOR }
    if (!submitButtonFontColor) { submitButtonFontColor = SUBMIT_BUTTON_FONT_COLOR }
    if (!submitButtonFontSize) { submitButtonFontSize = SUBMIT_BUTTON_FONT_SIZE }
    if (!submitButtonFontStyle) { submitButtonFontStyle = SUBMIT_BUTTON_FONT_STYLE }
    if (!submitButtonFontWeight) { submitButtonFontWeight = SUBMIT_BUTTON_FONT_WEIGHT }

    const [billNumber, setBillNumber] = useState<string>('');
    const actionToken = 'ThreeRiversSearch';
    const dispatch = useDispatch();

    const handleSearch = () => {
        const fields = [
            { key: BILL_NUMBER_METADATA_KEY, value: billNumber.trim(), isWildCard: billNumberWildcard ?? BILL_NUMBER_WILDCARD },
        ];
        dispatch(setItemSearch({ searchBy: 'ThreeRivers', fields }, 'ItemSearch'));
        dispatch(getThreeRiversItems(fields, actionToken));
    }

    const handleReset = () => {
        dispatch(clearItemSearch());
        dispatch(resetItems());
        setBillNumber('');
    }

    return (
        <div style={{ margin: margin, padding: padding }}>
            {searchHelpText &&
                <Row>
                    <Col>
                        <p>{searchHelpText}</p>
                    </Col>
                </Row>
            }
            <Row>
                <Col>
                    <Form.Group controlId="billNumber">
                        <Form.Label>{billNumberLabel}</Form.Label>
                        <Form.Control type="input" placeholder={billNumberPlaceholder} value={billNumber} onChange={(e) => setBillNumber(e.target.value)} />
                    </Form.Group>
                </Col>
                <Col>
                    <Button className="brand-btn-primary" style={{
                        marginTop: '29px',
                        backgroundColor: checkStyleForDefault(resetButtonBackgroundColor, RESET_BUTTON_BACKGROUND_COLOR),
                        borderColor: checkStyleForDefault(resetButtonBorderColor, RESET_BUTTON_BORDER_COLOR),
                        color: checkStyleForDefault(resetButtonFontColor, RESET_BUTTON_FONT_COLOR),
                        fontSize: checkStyleForDefault(resetButtonFontSize, RESET_BUTTON_FONT_SIZE),
                        fontStyle: checkStyleForDefault(resetButtonFontStyle, RESET_BUTTON_FONT_STYLE),
                        fontWeight: checkStyleForDefault3(resetButtonFontWeight)
                    }} onClick={handleReset} disabled={isFetching}>
                        {resetLabel}
                    </Button>
                    <Button className="brand-btn-primary" style={{
                        marginTop: '29px',
                        marginLeft: '8px',
                        backgroundColor: checkStyleForDefault(submitButtonBackgroundColor, SUBMIT_BUTTON_BACKGROUND_COLOR),
                        borderColor: checkStyleForDefault(submitButtonBackgroundColor, SUBMIT_BUTTON_BACKGROUND_COLOR),
                        color: checkStyleForDefault(submitButtonFontColor, SUBMIT_BUTTON_FONT_COLOR),
                        fontSize: checkStyleForDefault(submitButtonFontSize, SUBMIT_BUTTON_FONT_SIZE),
                        fontStyle: checkStyleForDefault(submitButtonFontStyle, SUBMIT_BUTTON_FONT_STYLE),
                        fontWeight: checkStyleForDefault3(submitButtonFontWeight)
                    }} disabled={billNumber.trim().length === 0 || isFetching} onClick={handleSearch}>
                        {searchLabel}
                    </Button>
                </Col>
            </Row>
        </div>
    )
}

const mapStateToProps = (state: IAppState) => {
    return {
        isFetching: state.account.isFetching,
    };
};

export default connect(mapStateToProps)(ThreeRiversSearch);
